import { KYMW1100Model } from '../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コープ商品URL取込クラス
 *
 * @export UpdateCoopGoodsUrlDataService
 * @class UpdateCoopGoodsUrlDataService
 * @extends {PlessUploadServiceSub}
 */
@Injectable()
export class UpdateCoopGoodsUrlDataService extends PlessJsonUploadServiceSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private fileKbn: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCoopGoodsUrlDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        FileKbn: this.fileKbn
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateCoopGoodsUrlDataService
   */
  execute(model: KYMW1100Model, file: File, fileKbn: string, successFunc: Function = null): void {
    this.model = model;
    this.fileKbn = fileKbn;
    this.successFunc = successFunc;
    this.sendFile('updateCoopGoodsUrlData', this.getBody(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateCoopGoodsUrlDataService
   */
  success(data: any): void {
    this.model.setCoopGoodsUrlDataKYMW0D00(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
